import config from "temp/config";

export const getShortLangCode = (locale?: string): string => {
    return locale?.includes("-") ? locale.split("-")[0] : locale ?? config.defaultLanguage;
};
